module.exports = __webpack_public_path__ + "img/b5.470c01c.jpg";